import { Component } from '@theme/component';

/** @extends {Component<{topic:HTMLSelectElement,helper:HTMLElement,orderWrap:HTMLElement,order:HTMLInputElement,formCard:HTMLElement}>} */
class VVContact extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.updateTopic();
  }

  updateTopic = () => {
    const option = this.refs.topic?.selectedOptions[0];
    if (!option) return;
    if (this.refs.helper) this.refs.helper.textContent = option.dataset.help || '';
    const needsOrder = ['order','quality'].includes(option.dataset.topic || '');
    if (this.refs.orderWrap) this.refs.orderWrap.hidden = !needsOrder;
    if (this.refs.order) this.refs.order.disabled = !needsOrder;
  };

  /** @param {Event} event */
  selectTopic = event => {
    if (!(event.target instanceof Element) || !this.refs.topic) return;
    const topic = event.target.closest('button[data-topic]')?.dataset.topic;
    const option = Array.from(this.refs.topic.options).find(item => item.dataset.topic === topic);
    if (!option) return;
    this.refs.topic.value = option.value;
    this.updateTopic();
    this.refs.formCard?.scrollIntoView({behavior:'auto',block:'start'});
    this.refs.topic.focus({preventScroll:true});
  };
}
if (!customElements.get('vv-contact')) customElements.define('vv-contact',VVContact);
